import { style } from '@vanilla-extract/css';

export const listItemElement = style({
  position: 'relative',

  selectors: {
    '&::marker': {
      color: 'var(--color)',
      fontSize: 'var(--font-size)',
      lineHeight: 'var(--line-height)',
      '@media': {
        'only screen and (--mobile)': {
          fontSize: 'var(--mobile-font-size, inherit)',
          lineHeight: 'var(--mobile-line-height, inherit)',
        },
      },
    },
  },
});
